/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { withFormik } from 'formik'
/** @todo No @types for yup so have to require over import to skip TSC */
const Yup = require('yup')

/**
 *     Import
 *     - Components
 */
import { Button } from '../../../common/Button/Button'
import { Alert } from '../../../common/Alert/Alert'
import Checkbox from '../../../common/Checkbox/Checkbox'
import ClaimForm from './components/ClaimForm'
import PopUp from '../../../common/PopUp/PopUp'

import { descriptions } from './texts'

import { get } from 'lodash'
import ClaimFormCP from './components/ClaimFormCP'
import { Redirect } from 'react-router-dom'

// let texts: any = {}

/**
 *     Form HTML
 */
class Step01FormHTML extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            toggle: false,
            claim: true,
            madeClaims: true,
            intendClaims: true,
            checkConfirmAllBelowPopUp: false,
            redirectToDashboard: false,
        }
    }

    /**
     * Both functions work as a hack to make calendar work properly
     */
    componentDidMount() {
        setTimeout(this.setClaim, 30)
        window.scrollTo(0, 0)
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, prevContext: any): void {
        const {
            quote,
            setFieldValue,
            values,
        } = this.props

        if (prevProps.quote.checkStep.done !== quote.checkStep.done && quote.checkStep.done) {
            setFieldValue('isCollectors', values.isCollectors)
            setFieldValue('isMuseums', values.isMuseums)
            setFieldValue('isDealersStock', values.isDealersStock)
            setFieldValue('isWineSpirits', values.isWineSpirits)
            setFieldValue('isCommercialProperty', values.isCommercialProperty)
        }
    }

    /**
     * Reset all quote data before going to next step
     *
     * @memberof Step01FormHTML
     */
    componentWillUnmount() {
        if (this.props.resetQuotes) {
            this.props.resetQuotes()
        }
    }

    setClaim = () => this.setState({ madeClaims: false, intendClaims: false })

    /**
     * On focus set Label element with class 'active'
     */
    focusChange = (event: any) => {
        event.target.parentNode.previousSibling.classList = 'active'
    }

    /**
     * Handle the changes on Custom elements like Checkbox
     */
    handleChangeCustom = (state: any, field: any) => {
        this.props.setFieldValue(field, state)
        this.props.setFieldTouched(field, true)
    }

    /**
     * Handle changes on Claim boxes
     */
    toggleClaim = (state: any, field: any) => {
        this.props.setFieldValue(field, state)
        this.props.setFieldTouched(field, true)
        this.setState({ [field]: state })
    }

    /**
     * Toggle all/none checkboxes group
     */
    toggleCheckBox = (state: any, field: any) => {
        this.setState({ toggle: state })
    }

    checkConfirmAllBelow = (event) => {
        const { values } = this.props
        event.preventDefault()
        if ((this.props.values.regularStockTaking !== true ||
            this.props.values.keepsRecordInDurableFormat !== true ||
            this.props.values.entrustedItemsAndAgreesAmountEventLoss !== true ||
            this.props.values.entrustOthersAndAgreesResponsibleForInsurance !== true) && !values.isCommercialProperty) {
            this.setState({ checkConfirmAllBelowPopUp: true })
        } else {
            this.props.handleSubmit(event)
        }
    }

    render() {
        const {
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            quote,
        } = this.props

        const { step01: { done = false, loading = false } } = quote

        let texts: any = {}

        if (quote.checkStep.done &&
            Object.keys(texts).length === 0 &&
            !this.props.editQuote &&
            Object.keys(values).length > 0) {
            texts = descriptions[(values.isCollectors === true || values.isWineSpirits === true) ? 'collectors' : (values.isMuseums === true) ? 'museums' : (values.isCommercialProperty === true ? 'commercialProperty' : 'art')]
        }

        if (this.props.editQuote && Object.keys(values).length > 0) {
            texts = descriptions[values.isCollectors === true || values.isWineSpirits === true ? 'collectors' : (values.isMuseums === true) ? 'museums' : (values.isCommercialProperty === true ? 'commercialProperty' : 'art')]
        }

        if (done && !loading && !this.props.editQuote) {
            this.props.history.push(`/quote/${this.props.match.params.id}/step02`)
        }

        let errorList: any[] = []
        let errorState: any = null // Fake errorState for test proposes
        if (errorState !== null) { errorList.push(errorState._data) }

        /**
         * Check if all fields have been filled
         */
        let allFilled = true
        if (quote.checkStep.done && !values.isCollectors && !values.isMuseums &&
            !values.isDealersStock && !values.isWineSpirits && !values.isCommercialProperty) {
            allFilled = !!values.turnover
        }

        // allFilled = false // Fake all filed for test proposes
        if (this.props.updateDirty) {
            this.props.dirty ? this.props.updateDirty(true) : this.props.updateDirty(false)
        }

        if (this.state.redirectToDashboard) {
            return (<Redirect to={`/dashboard`} />)
        }

        return (
            <div className="step01">

                {(this.state.checkConfirmAllBelowPopUp) ?
                    <PopUp
                        title={'Are you sure?'}
                        action={() => {
                            this.setState({ checkConfirmAllBelowPopUp: false })
                            this.props.handleSubmit(event)
                        }
                        }
                        buttonText={'Continue'}
                        numberButtons={2}
                        secondaryAction={() => { this.setState({ checkConfirmAllBelowPopUp: false }) }}
                        secondaryButtonText={'Cancel'}
                    >
                        You are unable to confirm 1 or all of the below ​statements​ :
                        <br /><br />
                        That The Client<br />
                        Undertakes regular stock taking.<br />
                        Keeps a record of all purchases & sales in a durable format.<br />
                        Keeps records of items entrusted to them and agrees in writing the net amount the entrustor is prepared to accept in the event of loss.<br />
                        Keeps records of items they entrust to others and agrees with them in writing who is responsible for the insurance.<br /><br />
                        Accordingly this quote will refer to underwriters at the end of the process. Click Continue to proceed with the quote or cancel to return to the page<br />
                    </PopUp>
                    : null}
                {(this.props.quote.step01.error && this.props.quote.step01.error.referrals) ?
                    <PopUp
                        title="Referral"
                        action={() => { this.setState({ redirectToDashboard: true }) }}
                        buttonText="Go back to dashboard"
                    >
                        HARD REFERRAL
                    </PopUp>
                    : null}

                {(!!Object.keys(this.props.errors).length && !!Object.keys(this.props.touched).length) && (
                    Object.keys(this.props.errors).filter(
                        (msg) => Object.keys(this.props.touched).includes(msg)
                    ).map((error, idx) => {
                        const msg = this.props.errors[error]
                        errorList.push(`${msg.charAt(0).toUpperCase()}${msg.slice(1)}`)
                    })
                )}

                {(errorList.length) ? (
                    <Alert type="error">
                        {errorList.map((a, i) => (<p key={i}>{a}</p>))}
                    </Alert>
                ) : null}

                <form className="quote__form" onSubmit={handleSubmit}>

                    {
                        (!values.isCollectors && !values.isMuseums && !values.isDealersStock && !values.isWineSpirits
                            && !values.isCommercialProperty) ?
                            <div>
                                <h4>Business financials</h4>
                                <h5>Please supply turnover for the business over the past financial year</h5>

                                <div className="quote__form__group fg-turn-over">
                                    <label>Turnover</label>

                                    <div className="input">
                                        <div className="input__pound">
                                            &pound;
                                        </div>
                                        <input
                                            type="number"
                                            min="0"
                                            step="any"
                                            name="turnover"
                                            id="turnover"
                                            placeholder="0"
                                            onChange={handleChange}
                                            onFocus={this.focusChange}
                                            onBlur={handleBlur}
                                            value={values.turnover}
                                        />
                                    </div>
                                </div>
                                <div className="quote__form__splitter quote__form__splitter--stripe" />
                            </div>
                            : null
                    }

                    <h4>Things about the client that we should know:</h4>
                    <h5>Please select any fields that apply</h5>

                    <div className="quote__form__group form__w100 ckgroup">

                        <Checkbox
                            onChange={this.handleChangeCustom}
                            first={true}
                            name="proposalOrRenewalRefusedOrDeclined"
                            selected={values.proposalOrRenewalRefusedOrDeclined}
                        >
                            {texts.text1}
                        </Checkbox>

                        <Checkbox
                            onChange={this.handleChangeCustom}
                            name="commercialInsurancePolicyCancelled"
                            selected={values.commercialInsurancePolicyCancelled}
                        >
                            {texts.text2}
                        </Checkbox>

                        {
                            texts.text3 && (!values.isCollectors && !values.isMuseums &&
                                !values.isDealersStock && !values.isWineSpirits && !values.isCommercialProperty) ?
                                <Checkbox
                                    onChange={this.handleChangeCustom}
                                    name="specialTermsImposed"
                                    selected={values.specialTermsImposed}
                                >
                                    {texts.text3}
                                </Checkbox>
                                : null
                        }

                        <Checkbox
                            onChange={this.handleChangeCustom}
                            name="criminalConvictionsOrCautions"
                            selected={values.criminalConvictionsOrCautions}
                        >
                            {texts.text4}
                        </Checkbox>

                        <Checkbox
                            onChange={this.handleChangeCustom}
                            name="prosecutionsPending"
                            selected={values.prosecutionsPending}
                        >
                            {texts.text5}
                        </Checkbox>

                        <Checkbox
                            onChange={this.handleChangeCustom}
                            name="declaredBankruptOrInsolvent"
                            selected={values.declaredBankruptOrInsolvent}
                        >
                            {texts.text6}
                        </Checkbox>

                        <Checkbox
                            onChange={this.handleChangeCustom}
                            last={true}
                            name="subjectCourtJudgmentDebt"
                            selected={values.subjectCourtJudgmentDebt}
                        >
                            {texts.text7}
                        </Checkbox>
                        {values.isCommercialProperty && (
                            <Checkbox
                                onChange={this.handleChangeCustom}
                                last={true}
                                name="domicile"
                                selected={values.domicile}
                            >
                                {texts.text8}
                            </Checkbox>
                        )}
                    </div>

                    {!values.isCommercialProperty && (
                        <div>
                            <div className="quote__form__splitter quote__form__splitter--stripe" />

                            <div className="quote__form__group form__w100">
                                <h4 className="quote__form__group form__w60 vmiddle pad0">You confirm that the client:</h4>
                                <div className="quote__form__group form__w40 vmiddle pad0">
                                    <Checkbox
                                        onChange={this.toggleCheckBox}
                                        short={true}
                                        first={true}
                                        last={true}
                                        name="toggle"
                                    >
                                        Confirm all the below
                                    </Checkbox>
                                </div>
                            </div>

                            <div className="quote__form__group form__w100 ckgroup">
                                <Checkbox
                                    onChange={this.handleChangeCustom}
                                    first={true}
                                    name="regularStockTaking"
                                    selectAll={this.state.toggle}
                                    selected={values.regularStockTaking}
                                >
                                    {texts.text8}
                                </Checkbox>

                                <Checkbox
                                    onChange={this.handleChangeCustom}
                                    name="keepsRecordInDurableFormat"
                                    selectAll={this.state.toggle}
                                    selected={values.keepsRecordInDurableFormat}
                                >
                                    {texts.text9}
                                </Checkbox>

                                <Checkbox
                                    onChange={this.handleChangeCustom}
                                    name="entrustedItemsAndAgreesAmountEventLoss"
                                    selectAll={this.state.toggle}
                                    selected={values.entrustedItemsAndAgreesAmountEventLoss}
                                >
                                    {texts.text10}
                                </Checkbox>

                                <Checkbox
                                    onChange={this.handleChangeCustom}
                                    last={true}
                                    name="entrustOthersAndAgreesResponsibleForInsurance"
                                    selectAll={this.state.toggle}
                                    selected={values.entrustOthersAndAgreesResponsibleForInsurance}
                                >
                                    {texts.text11}
                                </Checkbox>
                            </div>
                        </div>
                    )}

                    <div className="quote__form__splitter quote__form__splitter--stripe" />

                    <h4>Claims</h4>

                    <div className="quote__form__group form__w100 ckgroup">
                        <Checkbox
                            onChange={this.toggleClaim}
                            name="madeClaims"
                            first={true}
                            last={true}
                            selected={values.madeClaims}
                        >
                            {texts.text12}
                        </Checkbox>
                        {values.isCommercialProperty ? (<ClaimFormCP
                            name="madeClaimsArray"
                            show={this.state.madeClaims || values.madeClaims}
                            setFieldValue={this.handleChangeCustom}
                            extraClass={' step01'}
                            isCommercialProperty={values.isCommercialProperty}
                            ClaimDetails={values.madeClaimsArray}
                        />) : (<ClaimForm
                            name="madeClaimsArray"
                            show={this.state.madeClaims || values.madeClaims}
                            setFieldValue={this.handleChangeCustom}
                            extraClass={' step01'}
                            isCommercialProperty={values.isCommercialProperty}
                            ClaimDetails={values.madeClaimsArray}
                        />)}

                    </div>

                    {this.props.editQuote && this.props.dirty ? (
                        <div className="quote__form__group quote__form__group--update">
                            <Button
                                type="submit"
                            >
                                Update
                            </Button>
                        </div>
                    ) : null}

                    <div className="quote__form__group quote__form__group--submit">
                        <Button
                            type="submit"
                            onClick={(event) => { this.checkConfirmAllBelow(event); window.scrollTo(0, 0) }}
                            disabled={!allFilled}
                        >
                            Save and continue
                        </Button>
                    </div>

                </form>
            </div>
        )
    }
}

/**
 *     Formik Validation Struture
 */
const Step01Form = withFormik<any, any>({
    enableReinitialize: true,
    mapPropsToValues: (props: any) => {
        return {
            turnover: (props.editQuote) ? ((props.data.quote) ? props.data.quote.turnover : props.data.renewal.turnover) : (get(props, 'fullQuote.turnover')) ? get(props, 'fullQuote.turnover', 0) : 0,
            proposalOrRenewalRefusedOrDeclined: (props.editQuote) ? (props.data.quote ? props.data.quote.proposalOrRenewalRefusedOrDeclined : props.data.renewal.proposalOrRenewalRefusedOrDeclined) : get(props, 'fullQuote.proposalOrRenewalRefusedOrDeclined', false),
            commercialInsurancePolicyCancelled: (props.editQuote) ? (props.data.quote ? props.data.quote.commercialInsurancePolicyCancelled : props.data.renewal.commercialInsurancePolicyCancelled) : get(props, 'fullQuote.commercialInsurancePolicyCancelled', false),
            specialTermsImposed: (props.editQuote) ? (props.data.quote ? props.data.quote.specialTermsImposed : props.data.renewal.specialTermsImposed) : get(props, 'fullQuote.specialTermsImposed', false),
            criminalConvictionsOrCautions: (props.editQuote) ? (props.data.quote ? props.data.quote.criminalConvictionsOrCautions : props.data.renewal.criminalConvictionsOrCautions) : get(props, 'fullQuote.criminalConvictionsOrCautions', false),
            prosecutionsPending: (props.editQuote) ? (props.data.quote ? props.data.quote.prosecutionsPending : props.data.renewal.prosecutionsPending) : get(props, 'fullQuote.prosecutionsPending', false),
            declaredBankruptOrInsolvent: (props.editQuote) ? (props.data.quote ? props.data.quote.declaredBankruptOrInsolvent : props.data.renewal.declaredBankruptOrInsolvent) : get(props, 'fullQuote.declaredBankruptOrInsolvent', false),
            subjectCourtJudgmentDebt: (props.editQuote) ? (props.data.quote ? props.data.quote.subjectCourtJudgmentDebt : props.data.renewal.subjectCourtJudgmentDebt) : get(props, 'fullQuote.subjectCourtJudgmentDebt', false),
            domicile: (props.editQuote) ? (props.data.quote ? props.data.quote.domicile : props.data.renewal.domicile) : get(props, 'fullQuote.domicile', false),
            regularStockTaking: (props.editQuote) ? (props.data.quote ? props.data.quote.regularStockTaking : props.data.renewal.regularStockTaking) : get(props, 'fullQuote.regularStockTaking', false),
            keepsRecordInDurableFormat: (props.editQuote) ? (props.data.quote ? props.data.quote.keepsRecordInDurableFormat : props.data.renewal.keepsRecordInDurableFormat) : get(props, 'fullQuote.keepsRecordInDurableFormat', false),
            entrustedItemsAndAgreesAmountEventLoss: (props.editQuote) ? (props.data.quote ? props.data.quote.entrustedItemsAndAgreesAmountEventLoss : props.data.renewal.entrustedItemsAndAgreesAmountEventLoss) : get(props, 'fullQuote.entrustedItemsAndAgreesAmountEventLoss', false),
            entrustOthersAndAgreesResponsibleForInsurance: (props.editQuote) ? (props.data.quote ? props.data.quote.entrustOthersAndAgreesResponsibleForInsurance : props.data.renewal.entrustOthersAndAgreesResponsibleForInsurance) : get(props, 'fullQuote.entrustOthersAndAgreesResponsibleForInsurance', false),
            madeClaims: (props.editQuote) ? (props.data.quote ? props.data.quote.madeClaims : props.data.renewal.madeClaims) : get(props, 'fullQuote.madeClaims', false),
            intendClaims: (props.editQuote) ? (props.data.quote ? props.data.quote.intendClaims : props.data.renewal.intendClaims) : get(props, 'fullQuote.intendClaims', false),
            madeClaimsArray: (props.editQuote) ? (props.data.quote ? props.data.quote.claimsList : props.data.renewal.claimsList) : get(props, 'fullQuote.claimsList', []),
            intendClaimsDescription: (props.editQuote) ? (props.data.quote ? props.data.quote.intendClaimsDescription : props.data.renewal.intendClaimsDescription) : get(props, 'fullQuote.intendClaimsDescription', ''),
            isCollectors: (props.editQuote) ? (props.data.quote ? props.data.quote.isCollectors : props.data.renewal.isCollectors) : props.quote.checkStep.response.isCollectors,
            isMuseums: (props.editQuote) ? (props.data.quote ? props.data.quote.isMuseums : props.data.renewal.isMuseums) : props.quote.checkStep.response.isMuseums,
            isDealersStock: (props.editQuote) ? (props.data.quote ? props.data.quote.isDealersStock : props.data.renewal.isDealersStock) : props.quote.checkStep.response.isDealersStock,
            isWineSpirits: (props.editQuote) ? (props.data.quote ? props.data.quote.isWineSpirits : props.data.renewal.isWineSpirits) : props.quote.checkStep.response.isWineSpirits,
            isCommercialProperty: (props.editQuote) ? (props.data.quote ? props.data.quote.isCommercialProperty : props.data.renewal.isCommercialProperty) : props.quote.checkStep.response.isCommercialProperty,
        }
    },

    validationSchema: Yup.object().shape({
        isCollectors: Yup.boolean(),
        isMuseums: Yup.boolean(),
        isDealersStock: Yup.boolean(),
        isWineSpirits: Yup.boolean(),
        isCommercialProperty: Yup.boolean(),
        turnover: Yup.number().when(
            ['isCollectors', 'isWineSpirits', 'isMuseums', 'isDealersStock', 'isCommercialProperty'], {
            is: false,
            then: Yup.number().required('The turnover value is required').positive(),
            otherwise: Yup.number().positive(),
        }),
        proposalOrRenewalRefusedOrDeclined: Yup.boolean(),
        commercialInsurancePolicyCancelled: Yup.boolean(),
        specialTermsImposed: Yup.boolean(),
        criminalConvictionsOrCautions: Yup.boolean(),
        prosecutionsPending: Yup.boolean(),
        declaredBankruptOrInsolvent: Yup.boolean(),
        subjectCourtJudgmentDebt: Yup.boolean(),
        domicile: Yup.boolean(),
        madeClaims: Yup.boolean(),
        intendClaims: Yup.boolean(),
        madeClaimsArray: Yup.array().when('madeClaims', {
            is: true,
            then: Yup.array().ensure().min(1, 'You need at least one claim'),
            otherwise: Yup.array().ensure(),
        }),
        intendClaimsDescription: Yup.string().when('intendClaims', {
            is: true,
            then: Yup.string().required('You need a to send a claim description'),
            otherwise: Yup.string().ensure(),
        }),
    }),

    validateOnChange: false,
    validateOnBlur: false,

    handleSubmit: (values, { props, setSubmitting, resetForm }) => {

        let content = {
            'quote': {
                'id': props.editRenewal ? props.renewalQuoteId : props.match.params.id,
                'turnover': values.turnover,
                'proposalOrRenewalRefusedOrDeclined': values.proposalOrRenewalRefusedOrDeclined,
                'commercialInsurancePolicyCancelled': values.commercialInsurancePolicyCancelled,
                'specialTermsImposed': values.specialTermsImposed,
                'criminalConvictionsOrCautions': values.criminalConvictionsOrCautions,
                'prosecutionsPending': values.prosecutionsPending,
                'declaredBankruptOrInsolvent': values.declaredBankruptOrInsolvent,
                'subjectCourtJudgmentDebt': values.subjectCourtJudgmentDebt,
                'domicile': values.domicile,
                'regularStockTaking': values.regularStockTaking,
                'keepsRecordInDurableFormat': values.keepsRecordInDurableFormat,
                'entrustedItemsAndAgreesAmountEventLoss': values.entrustedItemsAndAgreesAmountEventLoss,
                'entrustOthersAndAgreesResponsibleForInsurance': values.entrustOthersAndAgreesResponsibleForInsurance,
                'intendClaims': values.intendClaims,
                'intendClaimsDescription': (values.intendClaims) ? values.intendClaimsDescription : '',
                'madeClaims': values.madeClaims,
                'claimsList': values.madeClaimsArray,
                'isCollectors': values.isCollectors,
                'isMuseums': values.isMuseums,
                'isDealersStock': values.isDealersStock,
                'isWineSpirits': values.isWineSpirits,
                'isCommercialProperty': values.isCommercialProperty,
            },
        }

        if (props.editRenewal) {
            props.setStep01Renewals(content)
            props.getRenewalVariation(props.renewalQuoteId)
            resetForm()
        } else {
            props.setStep01(content)
            resetForm(content)
        }

        // resetForm(content)

        if (props.editQuote) {
            setTimeout(props.update, 500)
        }

    },

})(Step01FormHTML)

export default Step01Form



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step01/Step01.tsx